import React from 'react';
import Link from 'next/link';
import styles from './UserRoles.module.css';
import { FaUserGraduate, FaChalkboardTeacher, FaBuilding, FaCheck } from 'react-icons/fa';

const UserRoles = ({ isLightTheme }) => {
    return (
        <section className={`${styles.rolesSection} ${!isLightTheme ? styles.darkMode : ""}`}>
            <div className={styles.sectionHeader}>
                <span className={styles.sectionLabel}>User Roles</span>
                <h2 className={styles.sectionHeading}>Choose Your Path</h2>
            </div>

            <div className={styles.gridThree}>
                <div className={styles.roleCard}>
                    <div className={styles.roleIcon}>
                        <FaUserGraduate />
                    </div>
                    <h3 className={styles.roleTitle}>For Learners</h3>
                    <p className={styles.roleDescription}>
                        Gain skills that are actually in
                        demand. Our adaptive learning path ensures you master every
                        concept before moving forward.
                    </p>
                    <ul className={styles.roleList}>
                        <li>
                            <FaCheck className={styles.checkIcon} /> Apply For Internships,
                            Workshops, Sessions.
                        </li>
                        <li>
                            <FaCheck className={styles.checkIcon} /> Apply for 100+ Premium
                            Courses
                        </li>
                        <li>
                            <FaCheck className={styles.checkIcon} /> Earn Verified
                            Certificates and Badges For Toppers.
                        </li>
                    </ul>
                    <Link href="/register" className="small-gradient-btn">
                        Start Learning Now
                    </Link>
                </div>

                <div className={styles.roleCard}>
                    <div className={styles.roleIcon}>
                        <FaChalkboardTeacher />
                    </div>
                    <h3 className={styles.roleTitle}>For Instructors</h3>
                    <p className={styles.roleDescription}>
                        Your expertise has value. Create courses using our advanced tools,
                        engage with students through live sessions, and earn a steady
                        income.
                    </p>
                    <ul className={styles.roleList}>
                        <li>
                            <FaCheck className={styles.checkIcon} /> Intuitive Course
                            Builder
                        </li>
                        <li>
                            <FaCheck className={styles.checkIcon} /> Live Web Meetings
                        </li>
                        <li>
                            <FaCheck className={styles.checkIcon} /> High Revenue Share
                        </li>
                    </ul>
                    <Link href="/become-a-teacher" className="small-gradient-btn" >
                        Become an Instructor
                    </Link>
                </div>

                <div className={styles.roleCard}>
                    <div className={styles.roleIcon}>
                        <FaBuilding />
                    </div>
                    <h3 className={styles.roleTitle}>For Companies</h3>
                    <p className={styles.roleDescription}>
                        Recruitment is broken. Fix it with data. Filter candidates based
                        on their actual course performance and project scores, not just
                        their resumes.
                    </p>
                    <ul className={styles.roleList}>
                        <li>
                            <FaCheck className={styles.checkIcon} /> Access Pre-Vetted
                            Talent
                        </li>
                        <li>
                            <FaCheck className={styles.checkIcon} /> View Detailed Skill
                            Reports
                        </li>
                        <li>
                            <FaCheck className={styles.checkIcon} /> Reduce Hiring Time by
                            50%
                        </li>
                    </ul>
                    <Link href="/register-hr" className="small-gradient-btn">
                        Register Your Company
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default UserRoles;
